import _filter from 'lodash/filter';

export const isOnlyFoil = (customFoiledTextElementList, currentelement) => {
  if (customFoiledTextElementList.length > 1 || currentelement.printing_technique === 'DIGITAL') {
    return false;
  }
  if (customFoiledTextElementList.length === 1) {
    return currentelement.uuid === customFoiledTextElementList[0].uuid;
  }
  return true;
};

export const FOIL_KEY = {
  gold: {
    color: 'd0b554',
    backgroundImage:
      'linear-gradient(to right, #d0b554 4%, #b6951a 15%, #e4bb26 31%, #cea40d 77%, #ffd427)',
  },
  silver: {
    color: 'c0bebe',
    backgroundImage: 'linear-gradient(to right, #c4c4c4 4%, #8e8e8e 37%, #eeeeee 74%, #cacaca 99%)',
  },
  copper: {
    color: 'dda99a',
    backgroundImage:
      'linear-gradient(to right, #dda194 4%, #f1d6c4 37%, #efcfbe 70%, #dda99a 100%)',
  },
};

export const getTextColor = (color, printingTechnique, foilColor) => {
  if (printingTechnique === 'CUSTOM_FOIL' && foilColor && foilColor !== 'none') {
    // update with proper foil color
    return FOIL_KEY[foilColor].color;
  }
  return color;
};

export const getCustomFoiledTextElementList = elements => {
  return (
    _filter(elements, {
      content_type: 'TEXT',
      customizable: true,
      printing_technique: 'CUSTOM_FOIL',
    }) || []
  );
};

function isIeEleven() {
  const ua = window.navigator.userAgent;
  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10) === 11;
  }
  return false;
}

export const getFoilCssProperties = foilColor => {
  if (isIeEleven()) {
    return {};
  }

  return {
    WebkitTextFillColor: 'transparent',
    WebkitBackgroundClip: 'text',
    backgroundImage: FOIL_KEY[foilColor].backgroundImage,
  };
};
